import {
  IGetAllQualityCondition,
  IPaginateApiResponse,
  IQualityCondition,
} from "model";
import { PREFIX } from "utils/Const";
import { BaseApiService } from "./BaseApiService";
const prefix = PREFIX.qualityCondition;

class QualityConditionApiService extends BaseApiService {
  public getAllQualityCondition = (request: IGetAllQualityCondition) =>
    this.get<IPaginateApiResponse<IQualityCondition[]>>(`${prefix}`, {
      params: request,
    });
  public getQualityConditionById = (id: string) =>
    this.get<IQualityCondition>(`${prefix}/${id}`);
  public addQualityCondition = (request: Partial<IQualityCondition>) =>
    this.post<Partial<IQualityCondition>, IQualityCondition>(prefix, request);
  public editQualityCondition = (request: IQualityCondition) =>
    this.put<IQualityCondition, IQualityCondition>(prefix, request);
  public deleteQualityCondition = (id: string) =>
    this.delete<string>(`${prefix}/${id}`);
}

export default new QualityConditionApiService();
